import { observer } from 'mobx-react-lite';
import React from 'react';

import {
  ErrorState,
  LoadingState,
} from '../features/schedule/components/states';
import {
  CalendarView,
  DayDetailView,
  TrainingView,
} from '../features/schedule/components/views';
import { useHomeData, useHomeNavigation } from '../features/schedule/hooks';

/**
 * Main Calendar component - acts as a router between different view modes
 */
const Calendar: React.FC = observer(() => {
  // Get all necessary data and state
  const homeData = useHomeData();
  const navigationHandlers = useHomeNavigation(
    homeData.workspaceSlug!,
    homeData.format,
    homeData.isTrainingMode,
    homeData.trainingIdParam,
    homeData.calendarCurrentDate,
    homeData.calendarView
  );

  // Handle loading and error states
  if (homeData.isWorkspaceLoading) {
    return <LoadingState message="Загрузка workspace..." />;
  }

  if (homeData.isLoading) {
    return <LoadingState />;
  }

  if (homeData.hasError) {
    return <ErrorState onRetry={() => window.location.reload()} />;
  }

  // Route to appropriate view based on current mode
  if (homeData.isTrainingMode) {
    return (
      <TrainingView
        isTrainingMode={homeData.isTrainingMode}
        trainingIdParam={homeData.trainingIdParam}
        eventInstanceStore={homeData.eventInstanceStore}
        scheduleStore={homeData.scheduleStore}
        userStore={homeData.userStore}
        format={homeData.format}
      />
    );
  }

  if (!homeData.isDayDetail) {
    return (
      <CalendarView
        isDayDetail={homeData.isDayDetail}
        schedules={homeData.schedules}
        scheduleStore={homeData.scheduleStore}
        calendarView={homeData.calendarView}
        calendarCurrentDate={homeData.calendarCurrentDate}
        navigationHandlers={navigationHandlers}
      />
    );
  }

  return (
    <DayDetailView
      isDayDetail={homeData.isDayDetail}
      selectedDate={homeData.selectedDate}
      eventInstanceStore={homeData.eventInstanceStore}
      scheduleStore={homeData.scheduleStore}
      userStore={homeData.userStore}
      format={homeData.format}
      navigationHandlers={navigationHandlers}
    />
  );
});

export default Calendar;
